import './Categories.css'

function Categories(){
    return (
        <div className='Categories'>
            <button>category</button>
            <button>category</button>
            <button>category</button>
            <button>category</button>
            <button>category</button>
            <button>category</button>
            <button>category</button>
            <button>category</button>
            <button>category</button>
            <button>category</button>
            <button>category</button>
            <button>category</button>
            <button>category</button>
            <button>category</button>
        </div>
    )
}

export default Categories